import { Helmet } from 'react-helmet-async';

const SITE = 'Bethel Innovations LLC';
const ORIGIN = 'https://bethelinnovations.com';

/**
 * Per-route document title and metadata.
 *
 * The previous site had no head management at all: every page shared a single
 * title in search results, in the browser tab and in the screen-reader page
 * announcement (WCAG 2.4.2).
 */
const Seo = ({ title, description, path = '/', noindex = false }) => {
  const fullTitle = title ? `${title} | ${SITE}` : SITE;
  const url = `${ORIGIN}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
    </Helmet>
  );
};

export default Seo;
